import { render } from "./FiveSteps.vue?vue&type=template&id=4dc84e0c&scoped=true"
const script = {}

import "./FiveSteps.vue?vue&type=style&index=0&id=4dc84e0c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc84e0c"]])

export default __exports__